import {
  useTranslate,
  IResourceComponentsProps,
  CrudFilters,
  // useExport,
  // useNavigation,
  HttpError,
  getDefaultFilter,
} from "@pankod/refine-core";

import {
  // Avatar,
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  // Popover,
  Card,
  Input,
  Icons,
  Form,
  DatePicker,
  Select,
  NumberField,
  useSelect,
  Button,
  FormProps,
  Row,
  Col,
  SelectProps,
  Grid,
  // ExportButton,
} from "@pankod/refine-antd";

import dayjs from "dayjs";

import { OrderStatus } from "components/salesStatus";
// import { OrderStatus, OrderActions } from "components";

import { IOrder, IStore, IOrderFilterVariables, IOrganization, IOrderItem } from "interfaces";
import { useMemo } from "react";
import { isNull } from "lodash";

export const OrderList: React.FC<IResourceComponentsProps> = () => {

  // const { selectProps } = useSelect<IOrganization>({
  //   resource: "organizations",
  // });
  
  // const { selectProps:  selectStoreProps } = useSelect<IStore>({
  //   resource: "stores",
  // });

  const { tableProps, sorter, searchFormProps, filters } = useTable<
    IOrder,
    HttpError,
    IOrderFilterVariables
  >({
    resource: "orders",
    // initialSorter: [{
    permanentSorter: [{
      field: "cheque_date",
      order: "desc",
    }],
    syncWithLocation: false,
    metaData: {
      select: "id, title, cheque_date, status, amount, store_id, organization_id, organizations!orders_organization_id_fkey(id,title,debug), stores!orders_store_id_fkey(id,title)",
      // select: "id, title, cheque_date, status, amount, store_id, organization_id, organizations:organization_id(id,title,debug), stores:store_id(id,title)",
    },
      onSearch: (params) => {
        const filters: CrudFilters = [];
        const { q, store, organization, cheque_date, status } = params;

        filters.push({
          field: "title",
          operator: "contains",
          value: q,
        });

        filters.push({
          field: "store_id",
          operator: "eq",
          value: store,
        });

        filters.push({
          field: "organization_id",
          operator: "eq",
          value: organization,
        });

        filters.push({
          field: "status",
          operator: "eq",
          value: status,
        });

        filters.push(
          {
            field: "cheque_date",
            operator: "gte",
            value: cheque_date
              ? cheque_date[0].startOf("day").toISOString()
              : undefined,
          },
          {
            field: "cheque_date",
            operator: "lte",
            value: cheque_date
              ? cheque_date[1].endOf("day").toISOString()
              : undefined,
          },
        );

      return filters;
    },
  });

  const t = useTranslate();
  
  // const { show } = useNavigation();
  // const { isLoading, triggerExport } = useExport<IOrder>({
  //       sorter,
  //       filters,
  //       pageSize: 50,
  //       maxItemCount: 50,
  //       mapData: (item) => {
  //           return {
  //               id: item.id,
  //               amount: item.amount,
  //               orderNumber: item.title,
  //               status: item.status,
  //               sale: item.sale.title,
  //               store: item.store.title,
  //               organization: item.organization.title,
  //               // user: item.user.firstName,
  //           };
  //       },
  // });

  // const Actions: React.FC = () => (
  //   <ExportButton onClick={triggerExport} loading={isLoading} />
  // );

  const breakpoint = Grid.useBreakpoint();

  return (
    <Row gutter={[16, 16]}>
      <Col xl={6} lg={24} xs={24}>
        <Card bordered={false} title={t("orders.filter.title")}>
          <Filter
            formProps={searchFormProps}
            filters={filters || []}
          />
        </Card>
      </Col>
      <Col xl={18} xs={24}>
        <List
          // pageHeaderProps={{extra: <Actions />, title: t("orders.pageHeader.title")}}
        >
          <Table
            {...tableProps}
            expandable={{
              expandedRowRender: !breakpoint.xs
                ? expandedRowRender
                : undefined,
            }}
            rowKey="id"
            // onRow={(record) => ({
            //   onClick: (event: any) => {
            //     if (event.target.nodeName === "TD") {
            //         setEditId && setEditId(record.id);
            //       }
            //     },
            // })}
            // onRow={(record) => {
            //     return {
            //         onClick: () => {
            //           show("orders", record.id);
            //         },
            //     };
            // }}
           >
            <Table.Column
              key="title"
              dataIndex="title"
              title={t("orders.fields.orderNumber")}
              render={(value) => <TextField value={value} />}
            />
                        {/* <Table.Column<IOrder>
                            key="status.text"
                            dataIndex={["status", "text"]}
                            title={t("orders.fields.status")}
                            render={(value) => {
                                return <OrderStatus status={value} />;
                            }}
                            defaultSortOrder={getDefaultSortOrder(
                                "status.text",
                                sorter,
                            )}
                            sorter
                        /> */}
            <Table.Column
              align="right"
              key="amount"
              dataIndex="amount"
              title={t("orders.fields.amount")}
              // defaultSortOrder={getDefaultSortOrder(
              //   "amount",
              //   sorter,
              // )}
              // sorter
              render={(value) => {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                isNull(value) ? value = 0 : value;
                return (
                  <NumberField
                    options={{
                      currency: "UAH",
                      style: "currency",
                    }}
                    // value={value / 100}
                    value={value}
                  />
                );
              }}
            />
            <Table.Column
              key="organization_id"
              dataIndex={["organizations", "title"]}
              title={t("stores.fields.organizations")}
              defaultSortOrder={getDefaultSortOrder(
                "organizations.title",
                sorter,
              )}
              // filterDropdown={(props) => (
              //   <FilterDropdown {...props}>
              //     <Select
              //       style={{ minWidth: 200 }}
              //       mode="multiple"
              //       placeholder={t("select.organization")}
              //       {...selectProps}
              //     />
              //   </FilterDropdown>
              // )}
            />
            <Table.Column
              key="store_id"
              dataIndex={["stores", "title"]}
              title={t("orders.fields.store")}
              defaultSortOrder={getDefaultSortOrder(
                "stores.title",
                sorter,
              )}
              // filterDropdown={(props) => (
              //   <FilterDropdown {...props}>
              //     <Select
              //       style={{ minWidth: 200 }}
              //       mode="multiple"
              //       placeholder={t("select.organization")}
              //       {...selectProps}
              //     />
              //   </FilterDropdown>
              // )}
            />
            
                        {/* <Table.Column<IOrder>
                            key="products"
                            dataIndex="products"
                            title={t("orders.fields.products")}
                            render={(_, record) => (
                                <Popover
                                    content={
                                        <ul>
                                            {record.items.map((product) => (
                                                <li key={product.id}>
                                                    {product.title}
                                                </li>
                                            ))}
                                        </ul>
                                    }
                                    title="Products"
                                    trigger="hover"
                                >
                                    {t("orders.fields.itemsAmount", {
                                        amount: record.items.length,
                                    })}
                                </Popover>
                            )}
                        /> */}
                        
                        {/* <Table.Column<IOrder>
                            fixed="right"
                            title={t("table.actions")}
                            dataIndex="actions"
                            key="actions"
                            align="center"
                            render={(_value, record) => (
                                <OrderActions record={record} />
                            )}
                        /> */}
            <Table.Column
              dataIndex="cheque_date"
              title={t("orders.fields.chequeDate")}
              render={(value) => (
                <DateField value={value} format="LLL" />
              )}
              defaultSortOrder={getDefaultSortOrder("cheque_date", sorter)}
            />
            <Table.Column
              dataIndex="status"
              title={t("orders.fields.status")}
              render={(value) => {
                return <OrderStatus status={value} />;
              }}
              // defaultSortOrder={getDefaultSortOrder(
              //     "status.text",
              //     sorter,
              // )}
              // sorter
            />
          </Table>
        </List>
      </Col>
    </Row>
  );
};

const Filter: React.FC<{ formProps: FormProps; filters: CrudFilters }> = (
    props,
) => {
    const t = useTranslate();

    const { formProps, filters } = props;
    const { selectProps: storeSelectProps } = useSelect<IStore>({
        resource: "stores",
        defaultValue: getDefaultFilter("store.id", filters),
    });

    const { selectProps: organizationSelectProps } = useSelect<IOrganization>({
      resource: "organizations",
      // optionLabel: "title",
      defaultValue: getDefaultFilter("organizations.id", filters),
    });

    // const { selectProps: orderSelectProps } = useSelect<IStore>({
    //     resource: "orderStatuses",
    //     optionLabel: "text",
    //     optionValue: "text",
    //     defaultValue: getDefaultFilter("status.text", filters),
    // });

    // const { selectProps: userSelectProps } = useSelect<IStore>({
    //     resource: "users",
    //     optionLabel: "fullName",
    //     defaultValue: getDefaultFilter("user.id", filters),
    // });

    const { RangePicker } = DatePicker;

    const createdAt = useMemo(() => {
        const start = getDefaultFilter("cheque_date", filters, "gte");
        const end = getDefaultFilter("cheque_date", filters, "lte");

        const startFrom = dayjs(start);
        const endAt = dayjs(end);

        if (start && end) {
            return [startFrom, endAt];
        }
        return undefined;
    }, [filters]);

    const tr = "On The Way";
    const optionOrderStatuses: SelectProps['options'] = [
      { value: "Pending", label: t("enum.orderStatuses.Pending") },
      { value: "Ready", label: t("enum.orderStatuses.Ready") },
      { value: "On The Way", label: t(`enum.orderStatuses.${tr}`) },
      { value: "Delivered", label: t("enum.orderStatuses.Delivered") },
      { value: "Cancelled", label: t("enum.orderStatuses.Cancelled") },
    ];

    return (
      <Form
            layout="vertical"
            {...formProps}
            initialValues={{
              q: getDefaultFilter("title", filters),
              store: getDefaultFilter("store.id", filters),
              organizations: getDefaultFilter("organizations.id", filters),
              status: getDefaultFilter("status", filters, "in"),
              createdAt,
            }}
      >
            <Row gutter={[10, 0]} align="bottom">
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item label={t("orders.filter.search.label")} name="q">
              <Input
                placeholder={t("sales.filter.search.placeholder")}
                prefix={<Icons.SearchOutlined />}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item
              label={t("orders.filter.status.label")}
              name="status"
            >
              <Select
                options={optionOrderStatuses}
                // {...OptionsOrderStatuses}
                allowClear
                // onChange={handleChange}
                placeholder={t("orders.filter.status.placeholder")}
              />
            </Form.Item>
          </Col>
          <Col xl={24} md={8} sm={12} xs={24}>
            <Form.Item
              label={t("orders.filter.organization.label")}
              name="organization"
            >
              <Select
                {...organizationSelectProps}
                allowClear
                // mode="multiple"
                placeholder={t("orders.filter.organization.placeholder")}
              />
            </Form.Item>
          </Col>
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item
                label={t("orders.filter.store.label")}
                name="store"
                    >
                <Select
                  {...storeSelectProps}
                  allowClear
                  placeholder={t("orders.filter.store.placeholder")}
                />
              </Form.Item>
            </Col> 
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item
                label={t("orders.filter.chequeDate.label")}
                name="cheque_date"
              >
                <RangePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xl={24} md={8} sm={12} xs={24}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  block
                >
                  {t("orders.filter.submit")}
                </Button>
              </Form.Item>
            </Col>
          </Row>
      </Form>
    );
};

const OrderItemsTable: React.FC<{ record: IOrder }> = ({ record }) => {
  const t = useTranslate();

  const { tableProps: postTableProps } = useTable<IOrderItem>({
    resource: "items",
    hasPagination: false,
    defaultSetFilterBehavior: "replace",
    permanentSorter: [{
      field: "line_num",
      order: "desc",
    }],
    metaData: {
      select: "id, title, line_num, price, amount, quantity, organization_id, order_id",
    },
    permanentFilter: [
    // initialFilter: [
      {
        field: "order_id",
        operator: "eq",
        value: record.id,
      },
    ],
    syncWithLocation: false,
  });

  // const {
  //     drawerProps: editDrawerProps,
  //     formProps: editFormProps,
  //     saveButtonProps: editSaveButtonProps,
  //     show: editShow,
  // } = useDrawerForm<IProduct>({
  //     action: "edit",
  //     resource: "products",
  //     redirect: false,
  // });

  // const moreMenu = (record: IProduct) => (
  //     <Menu
  //         mode="vertical"
  //         onClick={({ domEvent }) => domEvent.stopPropagation()}
  //     >
  //         <Menu.Item
  //             key="edit"
  //             style={{
  //                 fontSize: 15,
  //                 display: "flex",
  //                 alignItems: "center",
  //                 fontWeight: 500,
  //             }}
  //             icon={
  //                 <Icons.FormOutlined
  //                     style={{
  //                         color: "#52c41a",
  //                         fontSize: 17,
  //                         fontWeight: 500,
  //                     }}
  //                 />
  //             }
  //             onClick={() => editShow(record.id)}
  //         >
  //             {t("buttons.edit")}
  //         </Menu.Item>
  //     </Menu>
  // );

  return (
    <List title={t("products.products")} createButtonProps={undefined}>
      <Table {...postTableProps} rowKey="id">
        {/* <Table.Column
          dataIndex="images"
          render={(value) => <Avatar size={74} src={value[0].url} />}
          width={105}
        /> */}
        <Table.Column
          key="title"
          dataIndex="title"
          title={t("products.fields.name")}
        />
        <Table.Column
          align="right"
          key="price"
          dataIndex="price"
          title={t("products.fields.price")}
          render={(value) => {
            return (
              <NumberField
                options={{
                  currency: "UAH",
                  style: "currency",
                  // notation: "compact",
                }}
                // value={value / 100}
                value={value}
              />
            );
          }}
        />
        <Table.Column
          key="quantity"
          dataIndex="quantity"
          title={t("orders.fields.quantity")}
        />
        <Table.Column
          align="right"
          key="amount"
          dataIndex="amount"
          title={t("orders.fields.amount")}
          // defaultSortOrder={getDefaultSortOrder(
          //   "amount",
          //   sorter,
          // )}
          // sorter
          render={(value) => {
            return (
              <NumberField
                options={{
                  currency: "UAH",
                  style: "currency",
                }}
                // value={value / 100}
                value={value}
              />
            );
          }}
        />
      </Table>
      {/* <EditProduct
        drawerProps={editDrawerProps}
        formProps={editFormProps}
        saveButtonProps={editSaveButtonProps}
      /> */}
    </List>
  );
};

const expandedRowRender = (record: IOrder) => {
  return <OrderItemsTable record={record} />;
};